function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30.2,59.2c-3,0-6.1-0.5-9.1-1.4c-7.4-2.4-13.5-7.6-17-14.5c-3.5-7-4.2-14.9-1.8-22.3C6.4,8.7,17.3,0.7,30.2,0.7h1.5 v28.2l26.8,8.7L58,39c-2.4,7.4-7.6,13.5-14.5,17C39.3,58.2,34.8,59.2,30.2,59.2z M28.7,3.8c-10.9,0.6-20,7.6-23.5,18.1 c-2.2,6.7-1.6,13.8,1.6,20c3.2,6.2,8.6,10.9,15.3,13.1c6.7,2.2,13.8,1.6,20-1.6c5.8-3,10.2-7.8,12.5-13.9l-26-8.4V3.8z"
})))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M57.6,40.4l-28.9-9.4V0.7h1.5c16.1,0,29.3,13.1,29.3,29.3c0,3.2-0.4,6-1.4,9L57.6,40.4z M31.7,28.9l23.9,7.8 c0.6-2.2,0.9-4.3,0.9-6.7c0-14-11-25.4-24.8-26.2V28.9z"
}))))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 35.1,
  y: 2.2,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 18.6604 -22.621)",
  width: 3,
  height: 18
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 38.6,
  y: 6.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 26.0255 -22.4128)",
  width: 3,
  height: 27.8
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 45.9,
  y: 14.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 31.7832 -26.0849)",
  width: 3,
  height: 21.8
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 52,
  y: 25.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 38.0371 -28.5593)",
  width: 3,
  height: 12.4
})))));

var SvgCircleGraph = function SvgCircleGraph(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/circle-graph.d5b7c911.svg";
export { SvgCircleGraph as ReactComponent };